import * as ACTION_TYPES from './actiontypes';

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.BEGIN_WORK_REQUEST: {
      return {
        ...state,
        isLoading: true,
        statusMessage: 'Getting encounter to work'
      };
    }

    case ACTION_TYPES.BEGIN_WORK_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.BEGIN_WORK_FAILURE: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.SEARCH_REQUEST: {
      return {
        ...state,
        isLoading: true,
        statusMessage: 'Searching for matching encounters'
      };
    }

    case ACTION_TYPES.SEARCH_SUCCESS: {
      const { payload } = action;

      return {
        ...state,
        isLoading: false,
        statusMessage: '',
        numberOfEncounters: payload.numberOfEncounters
      };
    }

    case ACTION_TYPES.SEARCH_FAILURE: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.REMOVE_CODER: {
      const { payload } = action;

      const isNotSameId = x => x.value !== payload.coder.value;
      const nextSelectedCoders = state.selectedCoders.filter(isNotSameId);

      return {
        ...state,
        selectedCoders: nextSelectedCoders
      };
    }

    case ACTION_TYPES.SELECT_CODER: {
      const { payload } = action;

      const isSameId = x => x.value === payload.coder.value;
      const isDupe = state.selectedCoders.filter(isSameId).length > 0;

      const nextSelectedCoders = isDupe
        ? state.selectedCoders
        : state.selectedCoders.concat(payload.coder);

      return {
        ...state,
        selectedCoders: nextSelectedCoders
      };
    }

    case ACTION_TYPES.GET_CODERS_REQUEST: {
      return {
        ...state,
        isLoading: true,
        statusMessage: 'Getting coders for contract',
        selectedCoders: []
      };
    }

    case ACTION_TYPES.GET_CODERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.GET_CODERS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.CHANGE_INPUT_VALUE: {
      const { payload: { name, type, value } } = action;

      return {
        ...state,
        inputs: {
          ...state.inputs,
          [type]: {
            ...state.inputs[type],
            [name]: value
          }
        }
      };
    }

    case ACTION_TYPES.INIT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        statusMessage: 'Initializing page'
      };
    }

    case ACTION_TYPES.INIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    case ACTION_TYPES.INIT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        statusMessage: ''
      };
    }

    default: {
      throw Error('useAuditSearch reducer should never hit default case');
    }
  }
};

export default reducer;
